import type { State, ServicedeskPortalId } from './types.tsx';

export const getServicedeskPortalId = (state: State): ServicedeskPortalId | undefined =>
	state.portalId;
